import { getCookie } from './utils/cookies';

declare global {
	interface Window {
		dumbleData: any;
		_satellite: any;
		grecaptcha: any;
	}
}

export function initPayPortal3DumbleData() {
	window.dumbleData = {
		omniture: {
			page: {
				name: 'bookfairs_payment_portal',
				version: '3.0.0',
				pageAvailibility: false,
				pageError: false,
				stfAvailable: false,
				ewalletAvailable: false,
				taxError: false,
			},
		},
		user: {
			// Session
			userID: '',
			schoolName: '',
			fairStartDate: '',
			fairEndDate: '',
			fairID: '',
			certificateStatus: '',
			taxRate: 0.0,
			totalSales: 0.0,
			// New Purchase Page
			itemTotal: 0.0,
			itemTax: 0.0,
			amountDue: 0.0,
			// Confirmation Page
			paymentMethodtotal: {
				'Credit Card': 0.0,
				eWallet: 0.0,
				'Share the Fair': 0.0,
				Check: 0.0,
				Cash: 0.0,
				'Scholastic Dollars': 0.0,
				'Purchase Order': 0.0,
			},
			// eWallet
			ewalletPaymentamount: 0.0,
			ewalletLess: false,
			// STF
			availableBalance: 0.0,
			// Sales Total
			ccEwalletQty: 0,
			ccEwalletAmount: 0.0,
			tenderTotalQty: 0,
			tenderTotalAmount: 0.0,
			grossSalesTaxExemptTotal: 0.0,
			taxableSales: 0.0,
			grossSalesTotal: 0.0,
			taxTotal: 0.0,
			stfRedeemed: 0.0,
		},
		page: {
			name: 'bookfairs_payment_portal',
			version: '3.0.0',
			pageAvailibility: false,
			pageError: false,
			stfAvailable: false,
			ewalletAvailable: false,
			taxError: false,
		},
	};
}

export function updateLogInData() {
	if (window.dumbleData && window.dumbleData.user) {
		getCookie('SPS_UD').then((value) => {
			window.dumbleData.user.userID = value ? value.split('|')[0] : '';
		});
	}
}

export function setPageAvailabilityData(value: boolean) {
	if (window.dumbleData && window.dumbleData.page) {
		window.dumbleData.page.pageAvailibility = value;
	}
}

export function setPageErrorData(value: boolean) {
	if (window.dumbleData && window.dumbleData.page) {
		window.dumbleData.page.pageError = value;
	}
}

export function setStfAvailableData(value: boolean) {
	if (window.dumbleData && window.dumbleData.page) {
		window.dumbleData.page.stfAvailable = value;
	}
}

export function setEwalletAvailableData(value: boolean) {
	if (window.dumbleData && window.dumbleData.page) {
		window.dumbleData.page.ewalletAvailable = value;
	}
}

export function setTaxErrorData(value: boolean) {
	if (window.dumbleData && window.dumbleData.page) {
		window.dumbleData.page.taxError = value;
	}
}

export function updateSessionData(schoolName: string, fairStartDate: string, fairEndDate: string, fairID: number, certificateStatus: string, taxRate: number, totalSales: number) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.schoolName = schoolName;
		window.dumbleData.user.fairStartDate = fairStartDate;
		window.dumbleData.user.fairEndDate = fairEndDate;
		window.dumbleData.user.fairID = fairID;
		window.dumbleData.user.certificateStatus = certificateStatus;
		window.dumbleData.user.taxRate = taxRate;
		window.dumbleData.user.totalSales = totalSales;
	}
}

export function updateNewPurchasePageData(itemTotal: number, itemTax: number, amountDue: number) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.itemTotal = itemTotal;
		window.dumbleData.user.itemTax = itemTax;
		window.dumbleData.user.amountDue = amountDue;
	}
}

export function updateConfirmationPageData(paymentMethod: string, paymentMethodValue: number) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.paymentMethodtotal[paymentMethod] = paymentMethodValue;
	}
}

export function updateEWalletPaymentData(ewalletPaymentamount: number) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.ewalletPaymentamount = ewalletPaymentamount;
	}
}

export function updateEWalletInsufficientData(ewalletLess: boolean) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.ewalletLess = ewalletLess;
	}
}

export function updateSTFData(availableBalance: number) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.availableBalance = availableBalance;
	}
}

interface SalesTotal {
	ccAndeWalletQty: number;
	ccAndeWalletAmount: number;
	totalQty: number;
	totalAmount: number;
	taxExemptSales: number;
	taxableSales: number;
	grossTotal: number;
	taxTotal: number;
	stfRedeemed: number;
}

export function updateSalesTotalData({ ccAndeWalletQty, ccAndeWalletAmount, totalQty, totalAmount, taxExemptSales, taxableSales, grossTotal, taxTotal, stfRedeemed }: SalesTotal) {
	if (window.dumbleData && window.dumbleData.user) {
		window.dumbleData.user.ccEwalletQty = ccAndeWalletQty;
		window.dumbleData.user.ccEwalletAmount = ccAndeWalletAmount;
		window.dumbleData.user.tenderTotalQty = totalQty;
		window.dumbleData.user.tenderTotalAmount = totalAmount;
		window.dumbleData.user.grossSalesTaxExemptTotal = taxExemptSales;
		window.dumbleData.user.taxableSales = taxableSales;
		window.dumbleData.user.grossSalesTotal = grossTotal;
		window.dumbleData.user.taxTotal = taxTotal;
		window.dumbleData.user.stfRedeemed = stfRedeemed;
	}
}
